import React, { useEffect, useState } from "react"
import { Badge } from "@mui/material"
import useInformation from "hooks/useInformation"

const InfoBadgeWrapper = ({ children }) => {
  const [invisible, setInvisible] = useState(true)
  const { information } = useInformation()
  const { isRead } = information

  const settings = {
    color: "secondary",
    variant: "dot",
    invisible: invisible,
  }

  useEffect(() => {
    setInvisible(isRead)
  }, [isRead])

  return <Badge {...settings}>{children}</Badge>
}

export default InfoBadgeWrapper
